
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT,
    ASSIGN_FIRMWARE_GET_DEVICE_REQUEST,
    ASSIGN_FIRMWARE_SEARCH_REQUEST,
    ASSIGN_BULK_FIRMWARE_REQUEST,
    ASSIGN_FIRMWARE_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { assignFirmwareGetDeviceResult, assignFirmwareSearchResult, assignFirmwareResult, assignFirmwareSearchCamerasByAccountResult, bulkAssignFirmwareResult } from 'Redux/actions';

import { groupByHardwareVersion } from 'Core/data/Helpers';

function* getDevice({ payload }) {
    try {
        const QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        label
                        esn
                        imei
                        simCard {
                            iccId
                            msisdn
                            simProviderAccount {
                                id
                                name
                                simProviderId
                                simProvider {
                                    id
                                    name
                                }
                            }
                        }
                        deviceModel {
                            id
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                        }
                        unitConfig {
                            hardwareVersion
                        }
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["esn", "imei"],
                    terms: [payload],
                    exact: true
                },
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result;
            if (items.length > 0) {
                yield put(assignFirmwareGetDeviceResult(items[0]))
            } else {
                yield put(assignFirmwareGetDeviceResult({ error: true }))
            }
        }

    } catch (exc) {
        yield put(assignFirmwareGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/assignFirmware/redux/saga",
            "getDevice",
        )
    }
}

function* searchFirmwares({ payload }) {
    try {
        let QUERY = `
            query searchFirmwares ($conditions: [FirmwareSearchInput], $sort: [FirmwareSortInput], $limit: Int, $offset: Int) {
                result: searchFirmwares (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        manufacturerId
                        hardwareVersion
                        firmwareId
                        version
                        isDefault
                        build
                        isActive
                    }
                    total
                }
            }
        `;
        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["hardwareVersion"],
                        terms: payload,
                        exact: true
                    },
                    {
                        fields: ["build"],
                        terms: ["RELEASE", "BETA"],
                        exact: true
                    },
                    {
                        fields: ["isActive"],
                        terms: ["1"],
                        exact: true
                    },
                ],
                sort: {
                    field: "id",
                    order: "DESC"
                },
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            let { items } = data.result
            items = items.map((item) => ({ ...item, label: `${item?.version} - ${item?.build}${item?.isDefault ? '- Default' : ""}` }))
            yield put(assignFirmwareSearchResult(items))
        } else yield put(assignFirmwareSearchResult([]))

    } catch (exc) {
        yield put(assignFirmwareSearchResult([]))
        ExceptionManager(
            exc,
            "Modules/devices/.components/assignFirmware/redux/saga",
            "searchFirmwares",
        )
    }
}

function* assingFirmware({ payload }) {
    try {
        
        let QUERY = `
            mutation updateVidFleetAssignFirmware ($firmwareId: Int!, $hardwareVersion: String!, $scopes: [enumVidFleetScope]!, $unitIds: [Int]!) {
                updateVidFleetAssignFirmware (firmwareId: $firmwareId, hardwareVersion: $hardwareVersion, scopes: $scopes, unitIds: $unitIds)
            }
          `;

        let result = yield call(
            clientMutation,
            QUERY,
            {
                firmwareId: payload?.firmwareID,
                hardwareVersion: payload?.hardwareVersion,
                scopes: payload?.applyScopes,
                unitIds: payload.devices
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (result) {
            yield put(assignFirmwareResult({ upgrade: true }))
        } else {
            yield put(assignFirmwareResult({ upgrade: false }))
        }

    } catch (exc) {
        yield put(assignFirmwareResult({ upgrade: false }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/assignFirmware/redux/saga",
            "assingFirmware",
        )
    }
}

function* searchCamerasByAccount({ payload }) {
    try {
        const { companyId, allFirmwares } = payload;

        let QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        companyId
                        esn
                        label
                        deviceModel {
                            id
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                        }
                        unitConfig {
                            firmwareId
                            hardwareVersion
                        }
                    }
                    total
                }
            }
        `;

        let conditions = [
            {
                "fields": ["companyId"],
                "terms": [companyId],
                "exact": true,
            }, {
                "fields": ["deviceModel_manufacturer_name"],
                "terms": ["VidFleet"],
                "exact": true,
            },{
                "fields": ["status"],
                "terms": [1],
                "exact": true,
            }
        ]

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: conditions,
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            let firmwareList = []
            let hardwareVersionList = []
            let hardwareVersion = groupByHardwareVersion(data?.result?.items || [])
            if (hardwareVersion.length) {
                hardwareVersionList = hardwareVersion.map((item) => item?.hardwareVersion)
            }

            if (hardwareVersionList) {
                let QUERY_FIRMWARES = `
                    query searchFirmwares ($conditions: [FirmwareSearchInput], $sort: [FirmwareSortInput], $limit: Int, $offset: Int) {
                        result: searchFirmwares (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                            items {
                                id
                                manufacturerId
                                hardwareVersion
                                firmwareId
                                version
                                isDefault
                                build
                                isActive
                            }
                            total
                        }
                    }
                `;
                let datafirmwares = yield call(
                    clientQuery,
                    QUERY_FIRMWARES,
                    {
                        conditions: [
                            {
                                fields: ["hardwareVersion"],
                                terms: hardwareVersionList,
                                exact: true
                            },
                            {
                                fields: ["build"],
                                terms: ["RELEASE", "BETA"],
                                exact: true
                            },
                            {
                                fields: ["isActive"],
                                terms: ["1"],
                                exact: true
                            },
                        ],
                        sort: {
                            field: "id",
                            order: "DESC"
                        },
                        limit: 1000,
                        offset: 0
                    },
                    endpoints.GRAPHQL_GENERAL,
                );

                firmwareList = datafirmwares?.result?.items || []
            }
            let items = groupByHardwareVersion(data?.result?.items || [], firmwareList, allFirmwares)
            yield put(assignFirmwareSearchCamerasByAccountResult(items))
        } else {
            yield put(assignFirmwareSearchCamerasByAccountResult([]))
        }

    } catch (exc) {
        yield put(assignFirmwareSearchCamerasByAccountResult([]))
        ExceptionManager(
            exc,
            "Modules/devices/.components/assignFirmware/redux/saga",
            "searchCamerasByAccount",
        )
    }
}

function* bulkAssingFirmware({ payload }) {
    try {
        
        let mutation = `mutation updateVidFleetAssignFirmware ( $firmwareUpdateGroups: [FirmwareUpdateInput]!) {
                result: updateVidFleetAssignFirmware (firmwareUpdateGroups: $firmwareUpdateGroups)
            }`;

        const data =  yield call(
            clientMutation,
            mutation,
            {
                firmwareUpdateGroups: payload
            },
            endpoints.GRAPHQL_GENERAL,
        ); 

        if (data && data?.result) yield put(bulkAssignFirmwareResult({ update: true }))
        else yield put(bulkAssignFirmwareResult({ update: false }))

    } catch (exc) {
        yield put(bulkAssignFirmwareResult({ update: false }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/assignFirmware/redux/saga",
            "bulkAssingFirmware",
        )
    }
}

function* watchMethods() {
    yield takeEvery(ASSIGN_FIRMWARE_GET_DEVICE_REQUEST, getDevice);
    yield takeEvery(ASSIGN_FIRMWARE_SEARCH_REQUEST, searchFirmwares);
    yield takeEvery(ASSIGN_FIRMWARE_REQUEST, assingFirmware);
    yield takeEvery(ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT, searchCamerasByAccount);
    yield takeEvery(ASSIGN_BULK_FIRMWARE_REQUEST, bulkAssingFirmware);
}


export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}